<template>
  <base-layout>
    <div class="common-page my-cards">
      <div class="container-fluid">
        <h1 class="common-page__main-title">{{ $t('editCard') }}</h1>
        <dx-spinner :active="loading" />
        <dx-card-form
          v-if="!loading && card.id"
          :card="card"
          :disabled="sending"
          :edit="true"
          @submit="onSubmit"
          @cancel="onCancel"
          />
      </div>
    </div>
  </base-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BaseLayout } from '../layouts'
import {
  DxSpinner,
  DxCardForm
} from '../components'
export default {
  name: 'edit-card',
  components: {
    BaseLayout,
    DxSpinner,
    DxCardForm
  },
  data () {
    return {
      loading: true,
      sending: false
    }
  },
  methods: {
    ...mapActions([
      'loadMyCard',
      'updateMyCard'
    ]),
    onSubmit (data) {
      data.id = this.$route.params.id
      this.sending = true
      this.updateMyCard(data).then((result) => {
        this.sending = false
        if (result.success) {
          this.redirectToMyCards()
        }
      }).catch(() => {
        this.sending = false
      })
    },
    load () {
      this.loading = true
      this.loadMyCard(this.$route.params.id).then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onCancel () {
      this.redirectToMyCards()
    },
    redirectToMyCards () {
      this.$router.push({ name: 'myCards' })
    }
  },
  computed: {
    ...mapGetters({
      card: 'getMyCard'
    })
  },
  created () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/EditCard.vue